<template>
  <section class="text-center">
    <h3>{{ $t('contacts.unblockWarningTitle') }}</h3>
    <p class="mt-2 text-muted">
      {{ $t('contacts.unblockWarningSubtitle', { firstName: contact.firstname, lastName: contact.lastname }) }}
    </p>

    <section class="d-inline-flex full-width mt-3">
      <div class="ui-spacer" />
      <b-button class="mr-2" @click="$emit('close', true)">{{ $t('common.cancel') }}</b-button>
      <b-button :class="{'disabled': loading}" variant="danger" @click="unblockContact()">
        {{ $t('contacts.unblockBtn') }}
      </b-button>
    </section>
  </section>
</template>

<script>
import ContactService from '@/services/ContactService'

export default {
  name: 'UnblockContact',
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    unblockContact() {
      this.loading = true;
      ContactService.unBlockContact(this.contact.user_id).then(() => {
        this.$toast.success(
          this.$t('contacts.success.unblock', { firstName: this.contact.firstname, lastName: this.contact.lastname }),
          { toastClassName: ['toast-std', 'success-toast'] },
        );
      }).catch(err => {
        let error = this.$t('contacts.error.unblock');

        if (err.response && err.response.statusCode === 404) {
          error = this.$t('contacts.error.notInBlockList');
        }

        this.$toast.error(error, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
        this.$emit('ok', true);
      })
    },
  },
}
</script>
